import React from 'react';

import { EuiHorizontalRule } from '../../../../src/components/horizontal_rule';

export default () => (
  <div>
    <EuiHorizontalRule size="quarter" />
    <EuiHorizontalRule size="half" />
    <EuiHorizontalRule />
  </div>
);
